// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__20G3a","mirrored":"Icon_mirrored__2hP5n","sm":"Icon_sm__2V6EH","md":"Icon_md__3l_sO","lg":"Icon_lg__2i24L"};